$(document).on('click', '[data-id="comment-like-button"], [data-id="comment-like-icon"]', function(e) {
  e.preventDefault();

  // The data attributes to perform a like action are stored on the like button element.
  // Assign `$this` to be the the button element regardless of whether the icon or button
  // was clicked.
  const $this = $(this).parents('.comment-actions').find('[data-id="comment-like-button"]');
  const commentLikeURL = $this.data('comment-like-url');

  $.ajax({
    url: commentLikeURL,
    type: 'PATCH',
    success: function(data, textStatus, jqXHR) {
      $this.text(data.next_action);
      $this.parents('.comment-actions').find('.likes-count').replaceWith(data.likes_count_html);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      $this.text('Error!');
    }
  });
})
